import Tabs from '../tabs';

function ModuleContact(buttonsContainer, contentContainer, mapsContainers) {
	this.mapsContainers = mapsContainers;
	this.mapsContainers = [].slice.call(this.mapsContainers);

	this.locations = [];
	if (buttonsContainer && contentContainer) {
		this.tabs = new Tabs(buttonsContainer, contentContainer);
	}

	this.loadTabs = this.loadTabs.bind(this);

	if (this.tabs) {
		document.addEventListener('load', this.loadTabs);
	}
	this.loadMaps();
}

ModuleContact.prototype.loadTabs = function() {
	this.tabs = new Tabs(buttonsContainer, contentContainer);
};

ModuleContact.prototype.loadMaps = function() {
	if(this.mapsContainers.length < 1) {
		return;
	}

	if(typeof google === 'undefined' || typeof google.maps === 'undefined'){
		console.warn( 'Google maps api not loaded.' );
		return;
	}

	const defaultLocation = {'lat' : 52.4578558, 'lng' : 6.4946732};

	const mapOptions = {
		zoom: 12,
		disableDefaultUI: false,
		scrollwheel: false,
		mapTypeControl: false,
		streetViewControl: false,
		panControl: true,
		center: defaultLocation,
		mapTypeId: google.maps.MapTypeId.ROADMAP,
	};

	this.mapsContainers.forEach(container => {
		let name = container.getAttribute('data-location-name');
		let coordinates = {'lat' : parseFloat(container.getAttribute('data-latitude')), 'lng' : parseFloat(container.getAttribute('data-longitude'))};
		mapOptions.center = coordinates;
		this.locations.push(
			{
				'map': this.googleMap = new google.maps.Map(container, mapOptions),
				'name': name,
				'coordinates': coordinates
			}
		);
	});

	this.locations.forEach(location => {
		const marker = new google.maps.Marker({
			position: new google.maps.LatLng(location.coordinates.lat, location.coordinates.lng),
		});

		const infowindow = new google.maps.InfoWindow({
			content: location.name
		});

		google.maps.event.addListenerOnce(location.map, 'idle', function() {
			marker.setMap(location.map);
			infowindow.open(location.map, marker);
		});
	});
};

export default ModuleContact;